// https://www.dbos.dev/solutions/cloud-modernization

import { SiteLayout } from '@components/layout/SiteLayout';
import { Dropdown, DropdownList, DropdownToggle } from '@components/webflow';

export function SolutionsCloudModernizationPage() {
  return (
    <SiteLayout banner={true} footerCta={null}>
      <div className="background-glow-top-right">
        <section className="hero-center-wrapper">
          <h1 className="text-heading-caption">Cloud Modernization</h1>
          <h2 className="text-heading-h1">
            {'The Modern '}
            <span className="text-gradient">Cloud Modernization</span> <br />
            Platform
          </h2>
          <p className="text-body">
            {'Cloud-enabling legacy systems on a Linux-Kubernetes platform is so yesterday.\u00a0\u00a0'}
            <br />
            DBOS makes cloud modernization easier, reliable, and more secure - on any cloud or on premises
          </p>
          <div className="button-row-vertical">
            <div className="button-primary-border">
              <a href="/contact" className="button-cta button-primary button-navigation w-inline-block">
                <div className="text-block">Schedule a Demo</div>
              </a>
            </div>
            <a href="/blog/dbos-2024-gartner-cool-vendor" className="w-inline-block">
              <img
                src="/assets/images/6724211a9ec6f0803fe3cdea_Gartner-Cool-Vendor-Badge-DBOS.jpg"
                loading="lazy"
                width="100"
                height="100"
                alt="Gartner Cool Vendor 2024 - Badge"
                className="image-14"
              />
            </a>
          </div>
          <div className="card-creators-small">
            <p className="text-body-highlight">{'Based on 3 years of joint MIT-Stanford R&D, led by:'}</p>
            <div className="card-creators-items">
              <div className="w-layout-hflex profile-large">
                <img
                  src="/assets/images/675a594a3107ecdc86d8ebac_mike-stonebraker.png"
                  loading="lazy"
                  alt=""
                  className="profile-large-image"
                />
                <div className="div-block-28">
                  <div className="text-body text-body-highlight">Mike Stonebraker</div>
                  <div className="text-caption-lily">Founder, Postgres</div>
                </div>
              </div>
              <div className="w-layout-hflex profile-large">
                <img
                  src="/assets/images/675a5b414ba084e3c0fad7a4_matai-zaharia.png"
                  loading="lazy"
                  alt=""
                  className="profile-large-image"
                />
                <div className="div-block-28">
                  <div className="text-body text-body-highlight">Matei Zaharia</div>
                  <div className="text-caption-lily">Founder, Apache Spark</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="background-glow-center-left">
        <div className="spacer-3x" />
        <section className="section-wrapper">
          <div className="card-cta-large-wrapper">
            <div className="card-cta-large-glow-right">
              <div className="cta-large-content-left">
                <h2 className="text-heading-h2">
                  {'Durable, Secure  '}
                  <br />
                  {'Cloud Enablement for '}
                  <span className="text-gradient">Legacy Systems</span>
                </h2>
                <p className="text-body text-alignment-left">
                  DBOS (patent pending) removes the complexity, cost, and large cyberattack surface of traditional cloud
                  native stacks
                </p>
                <div className="button-row-horizontal">
                  <div className="button-primary-border">
                    <a
                      href="https://console.dbos.dev/"
                      className="button-cta button-primary button-navigation w-inline-block"
                    >
                      <div className="text-block">Explore the DBOS Console</div>
                    </a>
                  </div>
                  <div className="text-caption-micro">No credit card required.</div>
                </div>
                <h3 className="text-list-caption">Next-level cloud modernization</h3>
                <ul role="list" className="text-list">
                  <li className="text-list-item">Durable, observable cloud systems</li>
                  <li className="text-list-item">
                    Failure-proof, exactly-once processing across backend databases and APIs
                  </li>
                  <li className="text-list-item">Deploy on any cloud or on premises</li>
                </ul>
              </div>
              <div className="cta-large-content-right">
                <div className="card-testimonial-wrapper">
                  <p className="text-heading-h4">
                    {
                      '"What took us 2 months to build using a labyrinth of AWS resources took just 2 days on DBOS Cloud."'
                    }
                  </p>
                  <div className="w-layout-hflex card-testimonial-company">
                    <div className="card-testimonial-source">
                      <img
                        src="/assets/images/6724211a9ec6f0803fe3cdd8_ec4f6d1cc4abd2a47472a57d5590d5ad_TMcN.avif"
                        loading="lazy"
                        alt="Thomas McNally Portrait"
                        className="profile-medium-image"
                      />
                      <div className="w-layout-hflex card-testimonial-source-text">
                        <div className="text-body text-alignment-left">Thomas McNally</div>
                        <div className="text-caption-micro">VP Technology, TMG.io</div>
                      </div>
                    </div>
                    <img
                      src="/assets/images/6729b592490a06a163cae7c3_TMG.png"
                      loading="lazy"
                      alt="tmg Logo"
                      className="card-testimonial-logo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="spacer-3x" />
      </div>
      <section className="section-wrapper">
        <div className="card-use-cases">
          <h2 className="text-heading-caption">Cloud systems that run the way they're meant to, no matter what</h2>
          <h3 className="text-heading-h2">Cloud Modernization Reinvented...</h3>
          <div className="w-layout-hflex card-use-cases-row">
            <div className="w-layout-vflex card-use-cases-item">
              <h4 className="text-heading-h5">The cloud-native stack is broken</h4>
              <p className="text-body text-alignment-left">
                Linux, Containers, K8s? Too many layers. Too many admins. Too large an attack surface.
              </p>
            </div>
            <div className="w-layout-vflex card-use-cases-item">
              <h4 className="text-heading-h5">A better cloud stack from MIT-Stanford</h4>
              <p className="text-body text-alignment-left">
                A stateful serverless platform. Deploy with a click and scale to millions (or to zero!).
              </p>
            </div>
            <div className="w-layout-vflex card-use-cases-item">
              <h4 className="text-heading-h5">Perfect business execution on DBOS</h4>
              <p className="text-body text-alignment-left">
                Durable execution by default - no more lost orders, double charges or inventory errors.
              </p>
            </div>
            <div className="w-layout-vflex card-use-cases-item">
              <h4 className="text-heading-h5">100% auditable by default</h4>
              <p className="text-body text-alignment-left">
                OpenTelemetry observability data generated for every DBOS application.
              </p>
            </div>
          </div>
          <div className="card-insight-2-container">
            <a
              href="/webcast/stonebraker-increase-software-engineering-productivity"
              target="_blank"
              className="card-insight-large w-inline-block"
            >
              <img
                src="/assets/images/675a5852b2e31caf1ebb0c6b_increase-software-productivity-mike-stonebraker-webinar.png"
                loading="lazy"
                alt=""
                sizes="100vw"
                srcSet="/assets/images/675a5852b2e31caf1ebb0c6b_increase-software-productivity-mike-stonebraker-webinar-p-500.png 500w, /assets/images/675a5852b2e31caf1ebb0c6b_increase-software-productivity-mike-stonebraker-webinar-p-800.png 800w, /assets/images/675a5852b2e31caf1ebb0c6b_increase-software-productivity-mike-stonebraker-webinar-p-1080.png 1080w, /assets/images/675a5852b2e31caf1ebb0c6b_increase-software-productivity-mike-stonebraker-webinar.png 1238w"
                className="card-insight-image"
              />
              <div className="card-insight-large-content">
                <h4 className="text-heading-h4 text-heading-h4-insight">You're Doing it All Wrong</h4>
                <p className="text-body text-alignment-left">
                  Lightweight durable execution library versus heavyweight durable workflow orchestration services,
                  making programs crashproof without changing the way they're built
                </p>
                <div className="card-insight-meta">
                  <div className="w-layout-hflex profile-small profile-small-container">
                    <img
                      src="/assets/images/675a594a3107ecdc86d8ebac_mike-stonebraker.png"
                      loading="lazy"
                      alt=""
                      className="profile-small-image"
                    />
                    <div className="text-body text-body-highlight">Dr. Mike Stonebraker</div>
                  </div>
                  <div className="text-caption-micro">June 20, 2024</div>
                </div>
              </div>
            </a>
            <a href="/webcast/goodbye-lambda-hello-dbos" className="card-insight-large w-inline-block">
              <img
                src="/assets/images/6763d505bf044b488d647d79_DBOS-SAP-Cloud-Modernization-TMG.jpg"
                loading="lazy"
                alt=""
                sizes="100vw"
                srcSet="/assets/images/6763d505bf044b488d647d79_DBOS-SAP-Cloud-Modernization-TMG-p-500.jpg 500w, /assets/images/6763d505bf044b488d647d79_DBOS-SAP-Cloud-Modernization-TMG-p-800.jpg 800w, /assets/images/6763d505bf044b488d647d79_DBOS-SAP-Cloud-Modernization-TMG-p-1080.jpg 1080w, /assets/images/6763d505bf044b488d647d79_DBOS-SAP-Cloud-Modernization-TMG.jpg 1238w"
                className="card-insight-image"
              />
              <div className="card-insight-large-content">
                <h4 className="text-heading-h4 text-heading-h4-insight">Goodbye Lambda, Hello DBOS</h4>
                <p className="text-body text-alignment-left">
                  Lightweight durable execution library versus heavyweight durable workflow orchestration services,
                  making programs crashproof without changing the way they're built
                </p>
                <div className="card-insight-meta">
                  <div className="w-layout-hflex profile-small profile-small-container">
                    <img
                      src="/assets/images/6724211a9ec6f0803fe3cdd8_ec4f6d1cc4abd2a47472a57d5590d5ad_TMcN.avif"
                      loading="lazy"
                      alt="Thomas McNally Portrait"
                      className="profile-small-image"
                    />
                    <div className="text-body text-body-highlight">Thomas McNally, TMG</div>
                  </div>
                  <div className="text-caption-micro">June 20, 2024</div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
      <div className="spacer-3x" />
      <section className="section-wrapper">
        <div className="card-accordion-faq-alt">
          <div className="w-layout-hflex accordion-content-left">
            <h2 className="text-heading-caption">FAQs</h2>
            <h3 className="text-heading-h2">Common Questions</h3>
            <p className="text-body text-alignment-left text-margin-bottom">
              We’ll do our best to cover all bases.
              <br />
              {'In case you need more detail\u00a0\u00a0on cloud modernization with DBOS, speak with our team.'}
            </p>
            <a href="/contact" className="button-cta button-secondary w-inline-block">
              <div className="text-block">Speak with our team</div>
            </a>
          </div>
          <div className="w-layout-hflex accordion-content-right">
            <Dropdown data-hover="false" data-delay="0" className="card-accordion-faq w-dropdown">
              <DropdownToggle className="dropdown-toggle w-dropdown-toggle">
                <h3 className="text-accordion-title">What is cloud modernization?</h3>
                <div className="code-embed-2 w-embed">+</div>
              </DropdownToggle>
              <DropdownList className="dropdown-list w-dropdown-list">
                <div className="text-body-rich w-richtext">
                  <p>
                    Cloud modernization is the process of updating or replatforming legacy systems in order to leverage
                    cloud technologies and benefit from the accessibility and cost savings that they provide.
                  </p>
                </div>
              </DropdownList>
            </Dropdown>
            <Dropdown data-hover="false" data-delay="0" className="card-accordion-faq w-dropdown">
              <DropdownToggle className="dropdown-toggle w-dropdown-toggle">
                <h3 className="text-accordion-title">Challenges with cloud modernization?</h3>
                <div className="code-embed-2 w-embed">+</div>
              </DropdownToggle>
              <DropdownList className="dropdown-list w-dropdown-list">
                <div className="text-body-rich w-richtext">
                  <p>
                    {
                      'Cloud modernization is a challenging undertaking. Traditionally, it requires new infrastructure and new staff with cloud development and operations experience to manage and secure all layers of the new cloud system. '
                    }
                    <br />
                    <br />
                    Connecting cloud applications to legacy backends is often risky - unpredictable cloud outages and
                    timeouts can interfere with business transactions, resulting in lost orders, upset customers, fraud,
                    and more.
                  </p>
                  <p>
                    DBOS simplifies cloud modernization with a new stack and built-in durable execution, which
                    eliminates cloud business transaction errors.
                  </p>
                </div>
              </DropdownList>
            </Dropdown>
            <Dropdown data-hover="false" data-delay="0" className="card-accordion-faq w-dropdown">
              <DropdownToggle className="dropdown-toggle w-dropdown-toggle">
                <h3 className="text-accordion-title">Why modernize with DBOS?</h3>
                <div className="code-embed-2 w-embed">+</div>
              </DropdownToggle>
              <DropdownList className="dropdown-list w-dropdown-list">
                <div className="text-body-rich w-richtext">
                  <p>
                    {
                      'DBOS\u00a0simplifies the cloud stack, which makes it vastly easier to integrate or replatform legacy systems with cloud technology. '
                    }
                  </p>
                  <p>
                    {
                      'DBOS\u00a0is an alternative to the complex cloud native stack and also to traditional serverless compute platforms like AWS\u00a0Lambda. Based on years of joint MIT-Stanford R&D, DBOS\u00a0introduces a "stateful"\u00a0serverless platform with built-in durable execution and observability. '
                    }
                  </p>
                  <p>
                    {
                      'The DBOS\u00a0approach reduces cloud modernization coding effort by 10x, and runs at a fraction of the cost of most other platforms.'
                    }
                  </p>
                  <p>
                    {
                      'Most importantly, DBOS\u00a0durable execution with guaranteed exactly-once processing, ensures every business transact executes the way it was meant to, no mater what. '
                    }
                  </p>
                </div>
              </DropdownList>
            </Dropdown>
            <Dropdown data-hover="false" data-delay="0" className="card-accordion-faq w-dropdown">
              <DropdownToggle className="dropdown-toggle w-dropdown-toggle">
                <h3 className="text-accordion-title">Why is DBOS a 2024 Gartner Cool Vendor?</h3>
                <div className="code-embed-2 w-embed">+</div>
              </DropdownToggle>
              <DropdownList className="dropdown-list w-dropdown-list">
                <div className="text-body-rich w-richtext">
                  <p>
                    {'DBOS, a new '}
                    <a href="/dbos-transact">lightweight open source durable execution library</a>
                    {' and '}
                    <a href="/dbos-conductor">stateful serverless cloud platform as a service (PaaS)</a>
                    {
                      ', was designed to solve traditional cloud stack shortcomings by a joint MIT-Stanford R&D team, led by Postgres creator '
                    }
                    <a href="https://en.wikipedia.org/wiki/Michael_Stonebraker" target="_blank">
                      Mike Stonebraker
                    </a>
                    {', and Apache Spark creator '}
                    <a href="https://en.wikipedia.org/wiki/Matei_Zaharia" target="_blank">
                      Matei Zaharia
                    </a>
                    .
                  </p>
                  <p>
                    {'As a result, DBOS has been named as a '}
                    <a href="https://www.gartner.com/en/documents/5591459" target="_blank">
                      Cool Vendor in the 2024 Gartner Cool Vendors in Enabling Efficient Cloud Operations Report
                    </a>
                    . This recognition is another validation of DBOS and its ability to vastly simplify cloud
                    modernization and other digital initiatives.
                  </p>
                </div>
              </DropdownList>
            </Dropdown>
          </div>
        </div>
      </section>
      <div className="spacer-3x" />
    </SiteLayout>
  );
}
